export const isTrueLike = (value: boolean | string): boolean =>
  value === true || `${value}`?.toLowerCase() === "true";
